export const useRadarNotificationOpened = () => {};
